import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';

import { DesktopView, Feature, MobileView, PriceResult } from '../../components/HeroResultSection';
import { selectFilters } from '../../selectors/filters';
import { getHeaderText, getRoomsText } from './utils';
import { getReportState } from '../../selectors/report';
import { AgentAsideCardContainer } from '../AgentAsideCardContainer';
import { withVisibleInReportStatus } from '../../utils/report';
import { EReportStatus } from '../../constants/report';
import { selectEstimationPrettyPrices } from '../../selectors/estimation/selectEstimationPrettyPrices';
import { selectDealType } from '../../selectors/page';
import { EDealType } from '../../types/dealType';

import areaIcon from '../../components/HeroResultSection/icons/areaIcon.svg';
import buildIcon from '../../components/HeroResultSection/icons/buildIcon.svg';
import roomIcon from '../../components/HeroResultSection/icons/roomIcon.svg';

export const HeroResultSectionContainer_: React.FC = () => {
  const { address, roomsCount, area } = useSelector(selectFilters);
  const isDesktop = useDeviceType() === 'desktop';
  const roomsCountText = getRoomsText(roomsCount as number);
  const { reportDate } = useSelector(getReportState);
  const headerText = getHeaderText({ date: reportDate });
  const dealType = useSelector(selectDealType);
  const estimationPrices = useSelector(selectEstimationPrettyPrices);
  const priceDescription = dealType === EDealType.Sale ? 'Средняя оценка' : 'Средняя оценка ставки';
  /**
   * результаты оценки тут точно будут, попасть на этот экран без оценки невозможно
   */
  const { price, priceFrom, priceTo } = estimationPrices as NonNullable<typeof estimationPrices>;

  const Layout = isDesktop ? DesktopView : MobileView;

  const subheaderText = isDesktop ? (
    'Отчет сформирован с помощью сервиса Циан.Оценка. Риелтор уточнил параметры квартиры, исключил некоторые объявления из оценки, настроил прогноз и запросил кадастровую стоимость'
  ) : (
    <PriceResult
      price={price}
      priceDescription={priceDescription}
      priceRange={`${priceFrom}—${priceTo}`}
      priceRangeDescription="Диапазон оценки"
    />
  );

  return (
    <Layout
      headerText={headerText}
      subheaderText={subheaderText}
      agentCard={<AgentAsideCardContainer />}
      features={[
        <Feature key="build" testid="address" headerText={address} subheaderText="Адрес" icon={buildIcon} />,
        <Feature
          key="rooms"
          testid="rooms-count"
          headerText={roomsCountText}
          subheaderText="Комнатность"
          icon={roomIcon}
        />,
        <Feature key="area" testid="area" headerText={`${area} м²`} subheaderText="Площадь" icon={areaIcon} />,
      ]}
    />
  );
};

HeroResultSectionContainer_.displayName = 'HeroResultSectionContainer';

export const HeroResultSectionContainer = withVisibleInReportStatus({ notIn: [EReportStatus.Default] })(
  HeroResultSectionContainer_,
);
